/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */

/*
Fixed issue that was in refrence plunker. Here is updated plunker
    http://plnkr.co/edit/iAqDVXJRbMMUH2K7qXzE?p=preview
Ref : http://plnkr.co/edit/SZU3OUu0EH5IuydqR0jY?p=preview
*/
import utilityService from './utility.service';

const windbarbService = () => {
  const content = {};
  const WindBarbArrowHandler = (speed, direction, arrowWidth) => {
    const windBarbArrowHandler = {};
    windBarbArrowHandler.speed = speed;
    windBarbArrowHandler.direction = direction;
    windBarbArrowHandler.getExtraPadding = () => {
      let extraPadding = 0.3;
      if (windBarbArrowHandler.fifty) {
        extraPadding = 1.8;
      }
      // console.log("@@@@@@@@", windBarbArrowHandler.fifty);
      return extraPadding;
    };
    windBarbArrowHandler.shortBar = () => {
      // Draw an horizontal short bar.
      windBarbArrowHandler.path += 'M8 2 L1 2 ';
    };

    windBarbArrowHandler.longBar = () => {
      // Draw an horizontal long bar.
      windBarbArrowHandler.path += 'M8 2 L0 2 ';
    };
    windBarbArrowHandler.addTen = (index) => {
      // Draw an oblique long segment corresponding to 10 kn.
      windBarbArrowHandler.path += `M${windBarbArrowHandler.getExtraPadding() + index} 0 L${windBarbArrowHandler.getExtraPadding() + index + 1} 2 `;
    };
    windBarbArrowHandler.addFive = (index) => {
      // Draw an oblique short segment corresponding to 10 kn.
      windBarbArrowHandler.path += `M${windBarbArrowHandler.getExtraPadding() + index + 0.5} 1 L${windBarbArrowHandler.getExtraPadding() + index + 1} 2 `;
    };
    windBarbArrowHandler.addFifty = (index) => {
      // Draw a triangle corresponding to 50 kn.
      // M1.3 2 L1.3 0 L3 2
      windBarbArrowHandler.path += `M${1.3 + index} 2 L${1.3 + index} 0 L${3 + index} 2 Z`;
      // windBarbArrowHandler.path += "M" + index + " 0 L" + (index + 1)
      // + " 2 L" + index + " 2 L" + index + " 0 ";
    };
    windBarbArrowHandler.windArrow = () => {
      let index = 0;
      let i;
      let windArrowData;

      windBarbArrowHandler.trigDirection = direction + 90;
      windBarbArrowHandler.scale = arrowWidth / 8;

      windBarbArrowHandler.ten = 0;
      windBarbArrowHandler.five = 0;
      windBarbArrowHandler.fifty = 0;

      if (windBarbArrowHandler.speed > 0) {
        // Prepare the path
        windBarbArrowHandler.path = '';

        if (windBarbArrowHandler.speed < 8) {
          // Draw a single line
          windBarbArrowHandler.longBar();
          index = 1;
        } else {
          windBarbArrowHandler.shortBar();
        }
        // Find the number of lines in function of the speed
        windBarbArrowHandler.five = Math.floor(windBarbArrowHandler.speed / 5);
        if (windBarbArrowHandler.speed % 5 >= 3) {
          windBarbArrowHandler.five += 1;
        }

        // Add triangles (5 * 10)
        windBarbArrowHandler.fifty = Math.floor(windBarbArrowHandler.five / 10);
        windBarbArrowHandler.five -= windBarbArrowHandler.fifty * 10;
        // Add tenLines (5 * 2)
        windBarbArrowHandler.ten = Math.floor(windBarbArrowHandler.five / 2);
        windBarbArrowHandler.five -= windBarbArrowHandler.ten * 2;
        i = 0;
        // Draw first the triangles
        while (i < windBarbArrowHandler.fifty) {
          windBarbArrowHandler.addFifty(index + 2 * i);
          i += 1;
        }
        if (windBarbArrowHandler.fifty > 0) {
          index += 2 * (windBarbArrowHandler.fifty - 0.5);
        }
        i = 0;
        // Draw the long segments
        while (i < windBarbArrowHandler.ten) {
          windBarbArrowHandler.addTen(index + i);
          i += 1;
        }
        index += windBarbArrowHandler.ten;

        i = 0;
        // Draw the short segments
        while (i < windBarbArrowHandler.five) {
          windBarbArrowHandler.addFive(index + i);
          i += 1;
        }
        windBarbArrowHandler.path += 'Z';

        // WindBarbs
        windArrowData = {
          d: windBarbArrowHandler.path,
          'vector-effect': 'non-scaling-stroke',
          transform: {
            scale: windBarbArrowHandler.scale,
            rotate: windBarbArrowHandler.trigDirection,
            translate: {
              x: -4,
              y: -2,
            },
          },
          'barb-class': (windBarbArrowHandler.speed < 10
            ? 'light'
            : ((windBarbArrowHandler.speed >= 10 && windBarbArrowHandler.speed <= 20)
              ? 'moderate'
              : 'heavy')),
        };
      } else {
        // Circle for Calm Wind
        windArrowData = {
          'vector-effect': 'non-scaling-stroke',
          'barb-class': (windBarbArrowHandler.speed < 10
            ? 'light zero-wind'
            : ((windBarbArrowHandler.speed >= 10 && windBarbArrowHandler.speed <= 20)
              ? 'moderate zero-wind'
              : 'heavy zero-wind')),
        };
      }
      return windArrowData;
    };
    return windBarbArrowHandler;
  };

  content.getWindBarbConfig = (speed, direction, arrowWidth) => {
    // console.log(speed);
    // speed = 5;
    const windBarbArrowHandler = WindBarbArrowHandler(
      utilityService.roundToTenth(speed, 0),
      direction * 10,
      arrowWidth,
    );
    return windBarbArrowHandler.windArrow();
  };

  content.degToCompass = (angle) => {
    // Divide the angle by 22.5 because 360deg/16 directions  and adding 0.5 to get roundOff value
    const val = Math.floor((angle / 22.5) + 0.5);
    const arr = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW']; // Storing all the directions
    return arr[(val % 16)];
  };
  content.sayHello = () => 'sdss';
  return content;
};
export default windbarbService();
